import { useLocation} from 'react-router-dom';
const qs = require('query-string');

export function useQuery() {
　　const { search } = useLocation()
　　return qs.parse(search)
}